import React from 'react';
import PropTypes from 'prop-types';
import {Divider} from '@homeaway/react-collapse';
import CategoryCollection from '../CategoryCollection/CategoryCollection';
import {categoryPropTypes} from '../Category/Category';

import './DividerPanel.less';

function DividerPanel(props) {
    const {panelTitle, categories, isMobile} = props;
    const getGroupId = (title) => title && title.replace(/[^\w]/g, '');

    return (
        <div className="DividerPanel">
            <Divider id={getGroupId(panelTitle)} heading={panelTitle} expanded={!isMobile} key={panelTitle}>
                <CategoryCollection categories={categories} />
            </Divider>
        </div>
    );
}

DividerPanel.propTypes = {
    isMobile: PropTypes.bool,
    panelTitle: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape(...categoryPropTypes)).isRequired
};

DividerPanel.defaultProps = {
    isMobile: false
};

export default DividerPanel;
